import React, { useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import auth from '../../../api/auth/hooks'
import settings from '../../../api/settings/hooks'
import { ApplicationLanguage } from '../../../api/globalTypes'
import i18n from '../../../i18n'
import Loader from '../Loader'
import flags from './flags'

interface LangEntry {
    label: string
    flag?: string
}

const LanguageDropdown = () => {
    const [isLanguageDropdown, setIsLanguageDropdown] = useState(false)
    const selectedLang = localStorage.getItem('i18nextLng')

    const { data: availableLanguages } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.availableLanguages,
    })
    const { mutate: saveAgentLanguage } = auth.SaveAgentLanguage.useMutation()

    const langsObj =
        availableLanguages?.reduce<Record<string, LangEntry>>((acc, lang: ApplicationLanguage) => {
            acc[lang.abbreviation] = {
                label: lang.name,
                flag: flags[lang.abbreviation]?.flag,
            }

            return acc
        }, {}) ?? {}

    const isLangsObj = Object.keys(langsObj).length > 0

    const setDefaultLanguage = (language: string) => {
        i18n.changeLanguage(language)
    }

    const changeLanguageAction = (lang: string) => {
        setDefaultLanguage(lang)
        saveAgentLanguage(lang)
    }

    const toggleLanguageDropdown = () => {
        setIsLanguageDropdown(!isLanguageDropdown)
    }

    return (
        <React.Fragment>
            <Dropdown isOpen={isLanguageDropdown} toggle={toggleLanguageDropdown} className="ms-1 topbar-head-dropdown header-item">
                <DropdownToggle className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" tag="button">
                    {isLangsObj ? (
                        <img src={langsObj[selectedLang ?? '']?.flag} alt="App Language" height="20" className="rounded" />
                    ) : (
                        <Loader />
                    )}
                </DropdownToggle>
                <DropdownMenu className="notify-item language py-2">
                    {Object.keys(langsObj).map((key) => (
                        <DropdownItem
                            key={key}
                            onClick={() => changeLanguageAction(key)}
                            className={`notify-item ${selectedLang === key ? 'active' : 'none'}`}
                        >
                            <img src={langsObj[key]?.flag} alt={langsObj[key]?.label} className="me-2 rounded" height="18" />
                            <span className="align-middle">{langsObj[key]?.label}</span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

export default LanguageDropdown
